import React from "react";
import styles from "../assets/templates/FluencyInPairs.module.css";
import LessonInstruction from "../containers/instruction/LessonInstruction";

const FluencyInPairs = (props) => {
  // Check if the template has the model container.
  const hasModel = () => {
    const { blockData } = props;
    let instructionCount = 0;

    for (let i = 0; i < blockData.content.length; i++) {
      if (blockData.content[i].type === "instruction") instructionCount += 1;
    }

    return instructionCount >= 0;
  };

  const { blockData, contentIndex, audioUrl } = props;

  // sets background to white color
  const bgColor = blockData.content[contentIndex].type === "instruction" ? "new-bg-color" : "";
  const containerClasses = `default-card ${bgColor}`;

  return (
    <>
      <div className={containerClasses}>
        {blockData.content[contentIndex].type === "instruction" ? (
          <>
            <LessonInstruction
              instructionText={blockData.content[contentIndex].instruction}
              audioUrl={audioUrl}
            />
          </>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
            }}
          >
            <div className={styles["fluency-sentence"]}>
              {hasModel() ? (
                contentIndex !== 1 ? (
                  <h3> {blockData.content[contentIndex].en}</h3>
                ) : null
              ) : (
                <h3> {blockData.content[contentIndex].en} </h3>
              )}
            </div>
            {hasModel() && (
              <div className={styles["fluency-model"]}>
                <div className={styles["fluency-model-title"]}>Model</div>
                <div className={styles["fluency-model-text"]}>
                  {blockData.content[1].en}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default FluencyInPairs;
